import PropTypes from 'prop-types';
import LimitRulesType from './LimitRulesType';

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.number,
  limitRules: LimitRulesType
});
